import script from "./HeaderView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderView.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderView.vue?vue&type=style&index=0&id=66090d1e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66090d1e"]])

export default __exports__